export const INSTITUCIONAL_ASSISTANT_TYPE_ID = '61A351C4-64C5-42A3-88D1-E27F092551CD';

const isTrue = (value) => value === true || value === 'true' || value === 1 || value === '1';

export const getAssistantTypeId = (tipo) => {
  const value = tipo?.id || tipo?.Id || '';
  return typeof value === 'string' ? value.trim() : value;
};

export const getAssistantTypeName = (tipo) => {
  const value = tipo?.nombre || tipo?.Nombre || tipo?.name || tipo?.Name || '';
  return typeof value === 'string' ? value.trim() : value;
};

export const findAssistantTypeById = (tiposAsistente = [], tipoId) => {
  if (!tipoId) {
    return null;
  }

  return tiposAsistente.find((tipo) => getAssistantTypeId(tipo) === tipoId) || null;
};

export const isInstitutionalAssistantType = (tipo) => {
  if (!tipo) {
    return false;
  }

  const tipoId = getAssistantTypeId(tipo);
  const tipoNombre = (getAssistantTypeName(tipo) || '').toLowerCase();
  const esInstitucional = isTrue(tipo?.institucional ?? tipo?.Institucional);

  return (
    esInstitucional ||
    tipoNombre === 'institucional' ||
    tipoId?.toUpperCase?.() === INSTITUCIONAL_ASSISTANT_TYPE_ID
  );
};
